import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, access_token } = useSelector((state) => state.auth);

  if (!isLoggedIn || !access_token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
